<script>import { CachedSyncIterable } from "cached-iterable";
import { writable } from "svelte/store";
import { createEventDispatcher, tick } from "svelte";
import { initStores } from "./stores";
class CachedSyncIterableWrapper {
  // @ts-expect-error property gets assigned via Object.defineProperty
  iterable;
  constructor(iterable) {
    Object.defineProperty(this, "iterable", { value: iterable, enumerable: false });
  }
  [Symbol.iterator]() {
    return this.iterable[Symbol.iterator]();
  }
}
export let bundles = [];
const initialTick = tick();
const dispatch = createEventDispatcher();
$:
  cachedBundles = new CachedSyncIterableWrapper(CachedSyncIterable.from(bundles));
const bundlesStore = writable(cachedBundles);
$:
  $bundlesStore = cachedBundles;
initStores(bundlesStore, async (msg) => {
  await initialTick;
  dispatch("error", msg);
});
</script>

<slot />
